module.exports = "data:application/font-woff;base64,bW9kdWxlLmV4cG9ydHMgPSBfX3dlYnBhY2tfcHVibGljX3BhdGhfXyArICJhc3NldHMvZmEyNzcyMzI3ZjU1ZDgxOTgzMDFmZGI4YmNmYzgxNTgud29mZiI7"


//////////////////
// WEBPACK FOOTER
// ./~/bootstrap/dist/fonts/glyphicons-halflings-regular.woff
// module id = 358
// module chunks = 36